import { getDownloadURL, ref as storageRef, uploadBytesResumable } from "firebase/storage";
import { useEffect, useState } from "react";
import db, { storage } from "../Backend";
import { Timestamp, collection, doc, onSnapshot, orderBy, query, setDoc } from "firebase/firestore";
import { CircularProgress } from "@mui/material";
import PublishedTestimonies from "./PublishedTestimonies";
import { useNavigate } from "react-router-dom";

const Testimonyblogs = () => {
    const[imageselected,setImageselected]=useState(null);
    const [myname,setMyname]=useState("");
    const [myunit,setMyunit]=useState("");
    const [mychapter,setMychapter]=useState("");
    const [myTestimony,setMytestimony]=useState("");
    const [testimonies,setTestimonies]=useState([]);
    const [yearTestified,setYeartestified]=useState("");
    const [showUplaodProgress,setProgress]=useState(false);
    const [success,setSuccess]=useState(false);
    const [showLeftbar,setShowleftbar]=useState(false);
    const [showSearchfield,setShowSearchField]=useState(false);
    const navigate = useNavigate();
    const now = Timestamp.now();
    const timestamp = new Date().getTime(); 
    const senderID = new Date().toISOString().replace(/[^\w\s]|_/g, '');
    const dateSent = new Date(now?.toDate()).toUTCString();
    const todayDate = new Date();
    const year = todayDate.getFullYear().toString();
    // const formatToday = format(today,"yyyy-MM-dd");

    const handleSendToReview=async()=>{
         if(imageselected){
            try{
                setProgress(true);
                const storageref = storageRef(storage,`testifierpic/${myname+senderID}`);
                const uploadImage = uploadBytesResumable(storageref,imageselected);
                uploadImage.on(
                  (error)=>{
                    console.log(error);
                  },
                  ()=>{
                    getDownloadURL(uploadImage.snapshot.ref).then(async(downloadUrl)=>{
                      await setDoc(doc(db,"testimonyReview",senderID),{
                         username: myname,
                         user_unit: myunit,
                         user_chapter: mychapter,
                         testimony: myTestimony,
                         displaypic: downloadUrl,
                         year,
                         senderID,
                         dateSent,
                         timestamp 
                      });
                      setImageselected(null);
                      setProgress(false);
                      setSuccess(true);
                    })
                    .catch((error)=>{
                      setProgress(false);
                    });
                  }
                )
            }catch{

            }
 
          }else{
            try{
                await setDoc(doc(db,"testimonyReview",senderID),{
                    username: myname,
                    user_unit: myunit,
                    user_chapter: mychapter,
                    testimony: myTestimony,
                    displaypic: "",
                    year,
                    senderID,
                    dateSent,
                    timestamp 
                 });
              setImageselected(null);
              setProgress(false);
              setSuccess(true);
            }catch{

            }
        }
    };

    useEffect(()=>{
      const currentDate = new Date();
      setYeartestified(currentDate.getFullYear().toString());
    },[yearTestified]);

    useEffect(()=>{
      const collectionref = collection(db,"testimonyApproved");
    //   const q = query(collectionref,where("year","==",yearTestified), orderBy("timestamp","desc"));
    const q = query(collectionref, orderBy("timestamp","desc"));
      try{
          const unsub = onSnapshot(q,(snapshot)=>{
               const getdata = [];
               snapshot.forEach((doc)=>{
                   getdata.push(doc.data());
               });
               setTestimonies(getdata);
          });
           return unsub;
       }catch(err){
           console.log(err);
       }
    },[yearTestified]);

    const goTohome=()=>{
        navigate("/");
    };



    return ( 
        <div className="testimonyblogs">
            <div className="testimonybody">

                <div className="lefttestimonyblog">
                    <div className="createTestimonyBlog flex-column1">
                    
                        <h3>Write your Testimony 👇</h3>
                        <input id="profilepic" type="file" accept="image/*" style={{display:"none"}} onChange={(e)=>setImageselected(e.target.files[0])}/>
                        <label htmlFor="profilepic">
                            {imageselected !== null && imageselected !== "" ? 
                            <img src={URL.createObjectURL(imageselected)} alt="" />
                           :
                           <svg style={{cursor:"pointer"}}
                           viewBox="0 0 24 24"
                           fill="currentColor"
                           height="150px"
                           width="150px" >
                           <path d="M12 2A10.13 10.13 0 002 12a10 10 0 004 7.92V20h.1a9.7 9.7 0 0011.8 0h.1v-.08A10 10 0 0022 12 10.13 10.13 0 0012 2zM8.07 18.93A3 3 0 0111 16.57h2a3 3 0 012.93 2.36 7.75 7.75 0 01-7.86 0zm9.54-1.29A5 5 0 0013 14.57h-2a5 5 0 00-4.61 3.07A8 8 0 014 12a8.1 8.1 0 018-8 8.1 8.1 0 018 8 8 8 0 01-2.39 5.64z" />
                           <path d="M12 6a3.91 3.91 0 00-4 4 3.91 3.91 0 004 4 3.91 3.91 0 004-4 3.91 3.91 0 00-4-4zm0 6a1.91 1.91 0 01-2-2 1.91 1.91 0 012-2 1.91 1.91 0 012 2 1.91 1.91 0 01-2 2z" />
                            </svg>
                        }
                        </label>

                        {showUplaodProgress && 
                            <div><CircularProgress/></div>
                        }


                        <fieldset>
                            <legend>Your name</legend>
                            <input type="text" value={myname} onChange={e => setMyname(e.target.value)}/>
                        </fieldset>

                        <fieldset>
                            <legend>Unit name</legend>
                            <input type="text" value={myunit} onChange={e => setMyunit(e.target.value)}/>
                        </fieldset>

                        <fieldset>
                            <legend>Chapter name</legend>
                            <input type="text" value={mychapter} onChange={e => setMychapter(e.target.value)}/>
                        </fieldset>
                        
                        <fieldset>
                            <legend>Your Testimony</legend>
                            <textarea rows={30} value={myTestimony} onChange={e =>setMytestimony(e.target.value)}/>
                        </fieldset>

                            <button onClick={handleSendToReview}>Send for Review</button>
                    </div>
                </div>

                <div className="testimonyfeed flex-column2">
                    <div className="testimonyfeedtop flex-row2" style={{width:"100%"}}>
                        <h4>Life transforming Testimonies</h4>
                        <input type="search" placeholder="search for testimony"/>
                    </div>

                  
                        <div className="testimonyfeedtop-phone" style={{width:"100%"}}>
                            {!showSearchfield && 
                                <svg
                                onClick={goTohome}
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                height="2.5em"
                                width="2.5em">
                                <path d="M19 21a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v14a2 2 0 002 2h14zM12 7v4h5v2h-5v4l-5-5 5-5z" />
                              </svg>
                            }

                            {!showSearchfield && 
                                <div className="flex-row3" onClick={() => setShowleftbar(true)}
                                     style={{backgroundColor:"#1a1a1a",borderRadius:"10px",gap:"5px"}}>
                                         <h4 style={{color:"white"}}>Write your Testimony</h4>
                                         <svg
                                         id="writetestimonyicon"
                                         viewBox="0 0 24 24"
                                         fill="white"
                                     >
                                         <path d="M16 2H8C4.691 2 2 4.691 2 8v13a1 1 0 001 1h13c3.309 0 6-2.691 6-6V8c0-3.309-2.691-6-6-6zm4 14c0 2.206-1.794 4-4 4H4V8c0-2.206 1.794-4 4-4h8c2.206 0 4 1.794 4 4v8z" />
                                         <path d="M7 14.987v1.999h1.999l5.529-5.522-1.998-1.998zm8.47-4.465l-1.998-2L14.995 7l2 1.999z" />
                                         </svg>
                                 </div>
                            }
                       

                            <div className="flex-row3" onClick={()=>setShowSearchField(prev => !prev)}>
                                <h4>Search</h4>
                                <svg
                                id="phonesearchicon"
                                viewBox="0 0 24 24"
                                fill="currentColor">
                                <path d="M10 18a7.952 7.952 0 004.897-1.688l4.396 4.396 1.414-1.414-4.396-4.396A7.952 7.952 0 0018 10c0-4.411-3.589-8-8-8s-8 3.589-8 8 3.589 8 8 8zm0-14c3.309 0 6 2.691 6 6s-2.691 6-6 6-6-2.691-6-6 2.691-6 6-6z" />
                                </svg> 
                                <input className={`phonesearchblog ${showSearchfield ? 'show' : 'hide'}`} 
                                type="search" placeholder="search for testimony"/>
                            </div>
                        </div>            
                    

                    {testimonies && testimonies.map(data => (
                        <PublishedTestimonies
                            key={data.timestamp}
                            username={data.username}
                            user_unit={data.user_unit}
                            user_chapter={data.user_chapter}
                            year={data.year}
                            dateSent={data.dateSent}
                            timestamp={data.timestamp}
                            testimony={data.testimony}
                            displaypic={data.displaypic}
                            senderID={data.senderID}
                        />
                    ))}

                </div>
            </div>

            <div className={`lefttestimonyblog-phone ${showLeftbar ? 'open' : 'close'}`}>
                    <div className="createTestimonyBlog flex-column1">
                        <div className="flex-row3" style={{gap:"6px"}} onClick={()=>setShowleftbar(false)}>
                        <h3 style={{color:"white"}}>Close 👉</h3>
                        <svg
                        viewBox="0 0 24 24"
                        fill="white"
                        height="2.5em"
                        width="2.5em">
                        <path fill="none" d="M0 0h24v24H0z" />
                        <path d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM17 15.74L15.74 17 12 13.26 8.26 17 7 15.74 10.74 12 7 8.26 8.26 7 12 10.74 15.74 7 17 8.26 13.26 12 17 15.74z" />
                        </svg>
                        </div>
                       
                        <input id="profilepic" type="file" accept="image/*" style={{display:"none"}} onChange={(e)=>setImageselected(e.target.files[0])}/>
                        <label htmlFor="profilepic">
                            {imageselected !== null && imageselected !== "" ? 
                            <img src={URL.createObjectURL(imageselected)} alt="" />
                           :
                           <svg style={{cursor:"pointer"}}
                           viewBox="0 0 24 24"
                           fill="white"
                           height="150px"
                           width="150px" >
                           <path d="M12 2A10.13 10.13 0 002 12a10 10 0 004 7.92V20h.1a9.7 9.7 0 0011.8 0h.1v-.08A10 10 0 0022 12 10.13 10.13 0 0012 2zM8.07 18.93A3 3 0 0111 16.57h2a3 3 0 012.93 2.36 7.75 7.75 0 01-7.86 0zm9.54-1.29A5 5 0 0013 14.57h-2a5 5 0 00-4.61 3.07A8 8 0 014 12a8.1 8.1 0 018-8 8.1 8.1 0 018 8 8 8 0 01-2.39 5.64z" />
                           <path d="M12 6a3.91 3.91 0 00-4 4 3.91 3.91 0 004 4 3.91 3.91 0 004-4 3.91 3.91 0 00-4-4zm0 6a1.91 1.91 0 01-2-2 1.91 1.91 0 012-2 1.91 1.91 0 012 2 1.91 1.91 0 01-2 2z" />
                            </svg>
                        }
                        </label>

                        {showUplaodProgress && 
                            <div><CircularProgress/></div>
                        }


                        <fieldset>
                            <legend>Your name</legend>
                            <input type="text" value={myname} onChange={e => setMyname(e.target.value)}/>
                        </fieldset>

                        <fieldset>
                            <legend>Unit name</legend>
                            <input type="text" value={myunit} onChange={e => setMyunit(e.target.value)}/>
                        </fieldset>

                        <fieldset>
                            <legend>Chapter name</legend>
                            <input type="text" value={mychapter} onChange={e => setMychapter(e.target.value)}/>
                        </fieldset>
                        
                        <fieldset>
                            <legend>Your Testimony</legend>
                            <textarea rows={30} value={myTestimony} onChange={e =>setMytestimony(e.target.value)}/>
                        </fieldset>

                            <button onClick={handleSendToReview}>Send for Review</button>
                    </div>
            </div>

            {success && 
                  <div className="toast">
                  <p style={{color:"white",fontWeight:"bold"}}>
                    Your testimony has been sent for review by the appropriate leaders. 
                    When the review is successful, your testimony will be published for mass reading. 
                    Approved testimonies will appear under the life transforming testimonies feed section 
                    located on the right section of this page.
                 </p> 
                    <svg
                    cursor="pointer"
                    onClick={()=>setSuccess(false)}
                    viewBox="0 0 24 24"
                    fill="white"
                    height="30px"
                    width="30px">
                    <path fill="none" d="M0 0h24v24H0z" />
                    <path d="M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM17 15.74L15.74 17 12 13.26 8.26 17 7 15.74 10.74 12 7 8.26 8.26 7 12 10.74 15.74 7 17 8.26 13.26 12 17 15.74z" />
                    </svg>
              </div>
              }
        </div>
     );
}
export default Testimonyblogs;